import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const DecisionNumberFilter = ({ label = "l.searchFilter.decisionNumber", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"decisionNumber"} label={label} {...others} />
    </>
  );
};

export default DecisionNumberFilter;
